import { SLIDER_VALUES } from "./types";

export const CF_ACTIVE_SLIDER_DICTIONARY: {
  [key in SLIDER_VALUES]: SLIDER_VALUES;
} = {
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
};
